export default "__VITE_ASSET__C7VJLdae__"